import type {PickerScope} from './types'

export const reposPickerDefinitionsPath = (scope: PickerScope) =>
  `/repositories/picker/definitions?${getParamFromScope(scope)}`

interface ReposPickerRepositoriesPathProps {
  scope: PickerScope
  query?: string
}

export const reposPickerRepositoriesPath = ({scope, query}: ReposPickerRepositoriesPathProps) => {
  const params = [getParamFromScope(scope)]

  if (query) {
    params.push(`q=${encodeURIComponent(query)}`)
  }

  const queryString = params.length ? `?${params.join('&')}` : ''
  return `/repositories/picker/search${queryString}`
}

function getParamFromScope(scope: PickerScope) {
  if (scope.type === 'enterprise') {
    return `enterprise=${encodeURIComponent(scope.slug)}`
  }

  if (scope.type === 'organization' || scope.type === 'user') {
    return `owner=${encodeURIComponent(scope.slug)}`
  }

  return ''
}
